import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bars",
  "use": "icon-bars-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-bars\"><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-width=\"2\" d=\"M0 4h20M0 10h20M0 16h20\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol